import { createStore } from 'vuex';
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import rvoSync from './modules/rvoSync';

const store = createStore({
    state: {
        user: null,
        roleName: null,
        keeperLocationId: null,
        keeperUBN: null,
        keeperAssociationId: null,
        keeperRVORelationNumber: null,
        keeperRVOConnected: null,
        associationAdminAssociationId: null,
        associationAdminAssociationName: null,
        associationWebsiteURL: null,
        showloading: false,   
        hideConfigButton: false,
        isPinned: true,
        showConfig: false,
        sidebarType: "bg-white",
        isRTL: false,
        color: "success",
        isNavFixed: false,
        isAbsolute: false,
        showNavs: true,
        showSidenav: false,
        showNavbar: false,
        showFooter: true,
        showMain: true,
        isDarkMode: false,
        navbarFixed: "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
        absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
        bootstrap
    },    

    getters: {
        user: (state) => {
            return state.user;
        }
    },

    actions: {
        user(context, user) {
            context.commit('user', user);
        },

        setColor({ commit }, payload) {        
            commit("color", payload);
        }
    },

    mutations: {
        user(state, user) {
            state.user = user;
        },

        setTemporaryPasswordFlag(state, value) {
            if (state.user) {
                state.user.isTemporaryPassword = value;
            }
        },

        setRoleName(state, roleName) {
            state.roleName = roleName;
            sessionStorage.setItem('roleName', roleName);
        },

        setKeeperLocationId(state, id) {
            state.keeperLocationId = id;
            sessionStorage.setItem('keeperLocationId', id);
        },

        setKeeperUBN(state, ubn) {
            state.keeperUBN = ubn;
            sessionStorage.setItem('keeperUBN', ubn);
        },

        setKeeperAssociationId(state, id) {
            state.keeperAssociationId = id;
            sessionStorage.setItem('keeperAssociationId', id);
        },

        setKeeperRVORelationNumber(state, id) {
            state.keeperRVORelationNumber = id;
            sessionStorage.setItem('keeperRVORelationNumber', id);
        },

        setKeeperRVOConnected(state, id) {
            state.keeperRVOConnected = id;
            sessionStorage.setItem('keeperRVOConnected', id);
        },

        setAssociationAdminAssociationId(state, id) {
            state.associationAdminAssociationId = id;
            sessionStorage.setItem('associationAdminAssociationId', id);
        },

        setAssociationAdminAssociationName(state, id) {
            state.associationAdminAssociationName = id;
            sessionStorage.setItem('associationAdminAssociationName', id);
        },

        setAssociationWebsiteURL(state, id) {
            state.associationWebsiteURL = id;
            sessionStorage.setItem('associationWebsiteURL', id);
        },

        setShowLoading(state, showloading) {
            state.showloading = showloading;            
        },

        setShowNavbar(state, showNavbar) {
            state.showNavbar = showNavbar;            
        },

        toggleConfigurator(state) {
            state.showConfig = !state.showConfig;
        },

        toggleEveryDisplay(state) {
            state.showloading = !state.showloading;
            state.showNavbar = !state.showNavbar;
            state.showSidenav = !state.showSidenav;
            state.showFooter = !state.showFooter;
        },

        toggleHideConfig(state) {
            state.hideConfigButton = !state.hideConfigButton;
        },

        setIsPinned(state, payload) {
            state.isPinned = payload;
        },

        color(state, payload) {
            state.color = payload;
        },

        navbarMinimize(state) {
            const sidenavShow = document.getElementsByClassName("g-sidenav-show")[0];
      
            if (sidenavShow.classList.contains("g-sidenav-pinned")) {
                sidenavShow.classList.remove("g-sidenav-pinned");
                sidenavShow.classList.add("g-sidenav-hidden");
                state.isPinned = true;
            } else {
                sidenavShow.classList.remove("g-sidenav-hidden");
                sidenavShow.classList.add("g-sidenav-pinned");
                state.isPinned = false;
            }
        },

        navbarFixed(state) {
            state.isNavFixed = !state.isNavFixed;
        },
    },

    // 👇 REGISTER MODULE HERE
    modules: {
        rvoSync
    }
});

export default store;